/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_ImagenActa as ImagenActa,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_RespuestaActa as RespuestaActa,
  rec_t0 as t0,
  rec_y1 as y1,
} from "../../runtime/index.jsx";
export function FotosActa(e) {
  let t = (0, ReactCompiler.c)(18),
    { acta: n, datos: r, secciones: i, generales: a } = e,
    o,
    s;
  if (t[0] !== n || t[1] !== r || t[2] !== a || t[3] !== i) {
    s = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      let e;
      t[6] === n
        ? (e = t[7])
        : ((e = (e) => ({
            nombre: e.nombre,
            fotos: e.items.flatMap((e) =>
              n.archivos
                .filter((t) => t.campo === `foto:${e.id}`)
                .map((t) => ({
                  f: t,
                  item: e,
                })),
            ),
          })),
          (t[6] = n),
          (t[7] = e));
      let c = i.map(e).filter(t0);
      if (!c.length && !a.length) {
        s = null;
        break bb0;
      }
      let l;
      t[8] === n
        ? (l = t[9])
        : ((l = (e) => n.plantilla.items.indexOf(e) + 1),
          (t[8] = n),
          (t[9] = l));
      let u = l,
        d;
      t[10] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((d = (
            <p
              className={`text-sm font-semibold text-(--text-h)`}
              children={`📸 Fotos`}
            />
          )),
          (t[10] = d))
        : (d = t[10]);
      let f;
      t[11] !== n || t[12] !== a
        ? ((f = a.length > 0 && (
            <div
              className={`space-y-2`}
              children={[
                <p
                  className={`text-xs font-medium text-(--text)`}
                  children={`Vista general del lugar`}
                />,
                <div
                  className={`grid grid-cols-2 gap-2 sm:grid-cols-3`}
                  children={a.map((e) => (
                    <figure
                      key={e.id}
                      className={`space-y-1`}
                      children={
                        <ImagenActa actaId={n.id} archivo={e} alto={`h-28`} />
                      }
                    />
                  ))}
                />,
              ]}
            />
          )),
          (t[11] = n),
          (t[12] = a),
          (t[13] = f))
        : (f = t[13]);
      let p;
      (t[14] !== n || t[15] !== r || t[16] !== u
        ? ((p = (e) => (
            <div
              key={e.nombre}
              className={`space-y-2`}
              children={[
                <p
                  className={`text-xs font-medium text-(--text)`}
                  children={[
                    <span
                      aria-hidden={`true`}
                      children={[y1(e.nombre), ` `]}
                    />,
                    e.nombre,
                  ]}
                />,
                <div
                  className={`grid grid-cols-2 gap-2 sm:grid-cols-3`}
                  children={e.fotos.map((e) => {
                    let { f: t, item: i } = e;
                    return (
                      <figure
                        key={t.id}
                        className={`space-y-1`}
                        children={[
                          <ImagenActa
                            actaId={n.id}
                            archivo={t}
                            alto={`h-28`}
                          />,
                          <figcaption
                            className={`flex flex-col items-start gap-1 text-[11px] leading-tight`}
                            children={[
                              <span
                                className={`text-(--text-h)`}
                                children={[u(i), `. `, i.etiqueta]}
                              />,
                              <RespuestaActa
                                item={i}
                                valor={r.items?.[i.id]?.valor}
                                completa={!0}
                              />,
                            ]}
                          />,
                        ]}
                      />
                    );
                  })}
                />,
              ]}
            />
          )),
          (t[14] = n),
          (t[15] = r),
          (t[16] = u),
          (t[17] = p))
        : (p = t[17]),
        (o = <section className={`space-y-3`} children={[d, f, c.map(p)]} />));
    }
    ((t[0] = n), (t[1] = r), (t[2] = a), (t[3] = i), (t[4] = o), (t[5] = s));
  } else ((o = t[4]), (s = t[5]));
  return s === Symbol.for(`react.early_return_sentinel`) ? o : s;
}
